import { createElementFactory } from './create-element-factory.js';
export function createElement(tag, props, ...children) {
    const elementFactory = typeof tag === `string` ? createElementFactory(tag, replaceChildren) : tag;
    return elementFactory({ ...props, children });
}
function replaceChildren(element, childNodes) {
    element.replaceChildren(...childNodes);
}
//# sourceMappingURL=create-element.js.map